<div class="modal-header">
  <h2 class="modal-title" mat-dialog-title>
    <span *ngIf="data.config" trans>Update social links</span>
    <span *ngIf="!data.config">Add social links</span>
  </h2>
  <button type="button" (click)="close()" class="close-button no-style" tabindex="-1">
    <mat-icon svgIcon="close"></mat-icon>
  </button>
</div>

<form (ngSubmit)="createOrUpdate()" [formGroup]="form" ngNativeValidate>
  <div mat-dialog-content class="many-inputs">
    <div class="input-container" *ngFor="let service of services">
      <label [for]="service.name" class="capitalize" trans>{{ service.name }}</label>
      <input
        autocomplete="false"
        [type]="service.inputType || 'text'"
        [pattern]="service.pattern"
        [placeholder]="service.placeholder"
        [id]="service.name"
        [formControlName]="service.type"
      />
    </div>
  </div>

  <div class="buttons right" mat-dialog-actions>
    <button (click)="close()" type="button" mat-button class="button cancel cancel-button" trans>
      Cancel
    </button>
    <button
      type="submit"
      mat-raised-button
      color="accent"
      [disabled]="editor.loading$ | async"
      class="button primary submit-button"
    >
      <span *ngIf="data.config" trans>Update</span>
      <span *ngIf="!data.config" trans>Add</span>
    </button>
  </div>
</form>
